<app-menu></app-menu>

<section class="controlquestion-page" *ngIf="tenantId; else emptyState">
  <header class="page-header">
    <div>
      <p>Pesquisa / Questionários</p>
      <h1>ControlQuestion</h1>
      <small>Crie pesquisas e questionários com perguntas ricas, pesos e links de distribuição.</small>
    </div>
    <div class="actions">
      <button mat-raised-button color="primary" class="quick-actions-btn" type="button" (click)="openSurveyModal()">
        <span class="quick-actions-btn__label">Novo questionário</span>
      </button>
    </div>
  </header>

  <section class="panel filters" *ngIf="!activeSurvey">
    <mat-form-field appearance="outline" class="digital-field modal-standard-field cp-search-field">
      <mat-label>Pesquisar</mat-label>
      <mat-icon matIconPrefix>search</mat-icon>
      <input
        matInput
        type="search"
        placeholder="Buscar questionário por nome"
        [(ngModel)]="searchTerm"
        (ngModelChange)="loadSurveys()">
    </mat-form-field>

    <mat-form-field appearance="outline" class="digital-field modal-standard-field">
      <mat-label>Status</mat-label>
      <mat-select [(ngModel)]="statusFilter" (ngModelChange)="loadSurveys()">
        <mat-option value="ALL">Todos os status</mat-option>
        <mat-option value="DRAFT">Rascunho</mat-option>
        <mat-option value="PUBLISHED">Publicado</mat-option>
        <mat-option value="EXPIRED">Expirado</mat-option>
        <mat-option value="ARCHIVED">Arquivado</mat-option>
      </mat-select>
    </mat-form-field>
  </section>

  <section class="survey-grid" *ngIf="!activeSurvey && filteredSurveys.length">
    <article class="survey-card" *ngFor="let survey of filteredSurveys" (click)="openSurvey(survey)">
      <div class="survey-main">
        <div>
          <strong>{{ survey.title }}</strong>
          <small>{{ survey.description || 'Sem descrição' }}</small>
        </div>
        <div class="status-menu-wrapper">
          <button
            class="status-pill"
            type="button"
            [class]="surveyDisplayStatus(survey).toLowerCase()"
            (click)="toggleStatusMenu(survey.id, $event)">
            {{ surveyDisplayStatus(survey) }}
          </button>
          <div class="status-menu" *ngIf="openStatusMenuId === survey.id">
            <button type="button" (click)="setSurveyStatus(survey, 'DRAFT', $event)">Rascunho</button>
            <button type="button" (click)="setSurveyStatus(survey, 'PUBLISHED', $event)">Publicado</button>
            <button type="button" (click)="setSurveyStatus(survey, 'ARCHIVED', $event)">Arquivado</button>
          </div>
        </div>
      </div>
      <div class="survey-meta">
        <span>Criado em {{ survey.created_at | date:'short' }}</span>
        <div class="survey-actions">
          <div class="survey-link">
            <button class="icon-button" type="button" (click)="copySurveyLink(survey, $event)">
              <mat-icon>link</mat-icon>
            </button>
            <button class="icon-button" type="button" (click)="openMetricsModal(survey, $event)">
              <mat-icon>insights</mat-icon>
            </button>
            <span class="copy-feedback" *ngIf="copiedSurveyId === survey.id">{{ copiedSurveyMessage }}</span>
          </div>
          <div class="menu-wrapper">
            <button class="icon-button" type="button" (click)="toggleSurveyMenu(survey.id, $event)">
              <mat-icon>more_horiz</mat-icon>
            </button>
            <div class="survey-menu" *ngIf="openSurveyMenuId === survey.id">
              <button type="button" (click)="openSurveyEdit(survey, $event)">Editar</button>
              <button type="button" class="danger" (click)="deleteSurvey(survey, $event)">Excluir</button>
            </div>
          </div>
        </div>
      </div>
    </article>
  </section>

  <section class="survey-empty" *ngIf="!activeSurvey && !filteredSurveys.length">
    <div class="empty-canvas">
      <div class="empty-bubble">
        <strong>Comece aqui</strong>
        <p>Clique no botão "+" abaixo para criar seu primeiro questionário.</p>
      </div>
      <div class="empty-line"></div>
      <button type="button" class="empty-plus" (click)="openSurveyModal()">
        <mat-icon>add</mat-icon>
      </button>
    </div>
  </section>

  <section class="survey-editor" *ngIf="activeSurvey">
    <header class="editor-header">
      <div>
        <h2>{{ activeSurvey.title }}</h2>
        <small>Status: {{ activeSurvey.status }}</small>
      </div>
      <div class="editor-actions">
        <button mat-stroked-button type="button" (click)="openPreview()">Preview</button>
        <button mat-stroked-button type="button" (click)="openLinkModal()">Gerar link</button>
        <button mat-stroked-button type="button" (click)="closeSurvey()">Voltar</button>
      </div>
    </header>

    <div class="editor-body">
      <div class="builder">
        <div class="empty-canvas" *ngIf="!showQuestionForm">
          <div class="empty-bubble">
            <strong>Comece aqui</strong>
            <p>Clique no botão "+" abaixo para adicionar perguntas e elementos à pesquisa.</p>
          </div>
          <div class="empty-line"></div>
          <button type="button" class="empty-plus" (click)="openQuestionTypeModal()">
            <mat-icon>add</mat-icon>
          </button>
        </div>

        <div class="builder-form" *ngIf="showQuestionForm">
          <mat-form-field appearance="outline" class="digital-field modal-standard-field">
            <mat-label>Pergunta</mat-label>
            <input matInput type="text" [(ngModel)]="questionForm.title" placeholder="Escreva sua pergunta aqui">
          </mat-form-field>

          <mat-form-field appearance="outline" class="digital-field modal-standard-field">
            <mat-label>Descrição extra (opcional)</mat-label>
            <input matInput type="text" [(ngModel)]="questionForm.description" placeholder="Selecione uma ou mais respostas">
          </mat-form-field>

          <div class="answer-tools">
            <input #questionImageInput type="file" accept="image/*" hidden (change)="handleQuestionMedia($event, 'IMAGE')">
            <input #questionVideoInput type="file" accept="video/*" hidden (change)="handleQuestionMedia($event, 'VIDEO')">
            <button mat-stroked-button type="button" (click)="openQuestionImagePicker()">
              <mat-icon>image</mat-icon>
              Imagem
            </button>
            <button mat-stroked-button type="button" (click)="openQuestionVideoPicker()">
              <mat-icon>play_circle</mat-icon>
              Vídeo
            </button>
            <span class="media-preview" *ngIf="questionForm.media_url">
              {{ questionForm.media_type === 'VIDEO' ? 'Vídeo selecionado' : 'Imagem selecionada' }}
            </span>
          </div>

          <section class="answers" *ngIf="questionSupportsOptions()">
            <div class="answers-header">
              <span>Respostas</span>
              <button mat-stroked-button type="button" (click)="addOption()">
                {{ questionForm.question_type === 'IMAGE_CHOICE' ? 'Adicionar resposta de imagem' : 'Adicionar resposta' }}
              </button>
            </div>
            <ng-container *ngIf="questionForm.question_type !== 'IMAGE_CHOICE' && !['STAR', 'SCALE'].includes(questionForm.question_type); else fixedOrImageAnswers">
              <div class="answer-row" *ngFor="let option of optionDrafts; let i = index">
                <input type="text" [(ngModel)]="option.label" placeholder="Resposta">
                <div class="answer-row-actions">
                  <button
                    type="button"
                    class="correct-toggle"
                    *ngIf="supportsCorrectAnswers()"
                    [class.active]="option.is_correct"
                    [disabled]="option.is_other"
                    [title]="isSingleCorrectQuestion() ? 'Marcar resposta correta (única)' : 'Marcar resposta correta'"
                    (click)="toggleCorrectOption(i)">
                    <mat-icon>{{ isSingleCorrectQuestion() ? 'radio_button_checked' : 'check_circle' }}</mat-icon>
                    <span>Correta</span>
                  </button>
                  <button type="button" class="icon-button" (click)="removeOption(i)">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
              </div>
              <button mat-stroked-button type="button" class="full" (click)="addOtherOption()">+ Adicionar resposta "Outra"</button>
            </ng-container>
            <ng-template #fixedOrImageAnswers>
              <ng-container *ngIf="questionForm.question_type === 'STAR' || questionForm.question_type === 'SCALE'; else imageAnswers">
                <div
                  class="fixed-answers"
                  [ngClass]="{
                    'layout-row': questionForm.display_format === 'ROW',
                    'layout-column': questionForm.display_format === 'COLUMN',
                    'layout-grid': questionForm.display_format === 'GRID'
                  }">
                  <div class="answer-row answer-row-fixed" *ngFor="let option of optionDrafts">
                    <div class="answer-fixed-label">
                      <ng-container *ngIf="questionForm.question_type === 'STAR'; else fixedScaleLabel">
                        <span class="stars-inline">
                          <mat-icon *ngFor="let _ of getStarArray(option)">star</mat-icon>
                        </span>
                        <span>{{ option.label }}</span>
                      </ng-container>
                      <ng-template #fixedScaleLabel>
                        <span class="scale-pill">{{ option.label }}</span>
                      </ng-template>
                    </div>
                  </div>
                </div>
              </ng-container>
            </ng-template>
            <ng-template #imageAnswers>
              <div class="image-answers">
                <div class="image-answer" *ngFor="let option of optionDrafts; let i = index">
                  <input type="file" [id]="'option-image-' + i" accept="image/*" hidden (change)="handleOptionImage($event)">
                  <button type="button" class="image-upload" (click)="triggerOptionImage(i)">
                    <mat-icon>add_photo_alternate</mat-icon>
                    <span>{{ option.image_url ? 'Trocar imagem' : 'Carregar imagem' }}</span>
                  </button>
                  <img *ngIf="option.image_url" [src]="option.image_url" alt="Resposta">
                  <input type="text" [(ngModel)]="option.label" placeholder="Legenda (opcional)">
                  <div class="answer-row-actions">
                    <button
                      type="button"
                      class="correct-toggle"
                      *ngIf="supportsCorrectAnswers()"
                      [class.active]="option.is_correct"
                      [title]="'Marcar resposta correta'"
                      (click)="toggleCorrectOption(i)">
                      <mat-icon>radio_button_checked</mat-icon>
                      <span>Correta</span>
                    </button>
                    <button type="button" class="icon-button danger" (click)="removeOption(i)">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                </div>
              </div>
              <button mat-stroked-button type="button" class="full" (click)="addOption()">+ Adicionar resposta de imagem</button>
            </ng-template>
          </section>

          <section class="matrix" *ngIf="questionSupportsMatrix()">
            <div class="matrix-grid">
              <div>
                <div class="answers-header">
                  <span>Linhas</span>
                  <button mat-stroked-button type="button" (click)="addMatrixRow()">Adicionar linha</button>
                </div>
                <div class="answer-row" *ngFor="let row of matrixRowDrafts; let i = index">
                  <input type="text" [(ngModel)]="row.label" placeholder="Linha">
                  <button type="button" class="icon-button" (click)="removeMatrixRow(i)">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
              </div>
              <div>
                <div class="answers-header">
                  <span>Colunas</span>
                  <button mat-stroked-button type="button" (click)="addMatrixCol()">Adicionar coluna</button>
                </div>
                <div class="answer-row" *ngFor="let col of matrixColDrafts; let i = index">
                  <input type="text" [(ngModel)]="col.label" placeholder="Coluna">
                  <button type="button" class="icon-button" (click)="removeMatrixCol(i)">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </section>

          <div class="builder-actions">
            <button mat-stroked-button type="button" (click)="openQuestionTypeModal()">Alterar tipo</button>
            <button mat-stroked-button type="button" (click)="resetQuestionForm(true, true)">Limpar</button>
            <button mat-raised-button color="primary" class="cq-primary-btn" type="button" (click)="saveQuestion()">
              {{ editingQuestionId ? 'Salvar alterações' : 'Salvar pergunta' }}
            </button>
          </div>

        <section class="question-list">
          <h4>Perguntas adicionadas</h4>
          <div
            class="question-list-body"
            cdkDropList
            [cdkDropListData]="questions"
            (cdkDropListDropped)="reorderQuestions($event)">
            <div class="question-card" *ngFor="let question of questions" cdkDrag (click)="selectQuestion(question)">
              <div class="drag-handle" cdkDragHandle>
                <mat-icon>drag_indicator</mat-icon>
              </div>
              <div class="question-info">
                <strong>{{ question.title }}</strong>
                <small>{{ questionTypeLabel(question.question_type) }}</small>
              </div>
              <button class="icon-button danger" type="button" (click)="deleteQuestion(question); $event.stopPropagation()">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
          <p class="empty" *ngIf="!questions.length">Nenhuma pergunta criada ainda.</p>
        </section>
        </div>
      </div>

      <aside class="settings">
        <header>
          <h3>Configurações</h3>
          <button class="icon-button" type="button" (click)="resetQuestionForm()">
            <mat-icon>close</mat-icon>
          </button>
        </header>
        <mat-form-field appearance="outline" class="digital-field modal-standard-field">
          <mat-label>Tipo de pergunta</mat-label>
          <mat-select [(ngModel)]="questionForm.question_type" (selectionChange)="onQuestionTypeChange()">
            <mat-option *ngFor="let type of questionTypes" [value]="type.key" [disabled]="!type.enabled">{{ type.label }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="digital-field modal-standard-field">
          <mat-label>Formato de exibição</mat-label>
          <mat-select [(ngModel)]="questionForm.display_format">
            <mat-option *ngFor="let format of displayFormats" [value]="format.value">{{ format.label }}</mat-option>
          </mat-select>
        </mat-form-field>
        <div class="toggle-block">
          <mat-slide-toggle [(ngModel)]="questionForm.required">Pergunta obrigatória</mat-slide-toggle>
        </div>
        <button mat-raised-button color="primary" class="cq-primary-btn" type="button" (click)="openLinkModal()">Criar questionário</button>
      </aside>
    </div>
  </section>
</section>

<ng-template #emptyState>
  <div class="empty-state-full">Selecione um tenant para acessar o ControlQuestion.</div>
</ng-template>

<div class="cp-modal-backdrop" *ngIf="showSurveyModal" (click)="showSurveyModal = false"></div>
<section class="modal-card cp-modal-fixed-height controlquestion-survey-modal" *ngIf="showSurveyModal" (click)="$event.stopPropagation()">
  <header class="modal-header">
    <div>
      <h2>{{ editingSurveyId ? 'Editar questionário' : 'Novo questionário' }}</h2>
      <small>Configure os dados principais e publique no momento certo.</small>
    </div>
    <button class="icon" type="button" (click)="showSurveyModal = false">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <form class="cp-modal-body">
    <div class="cp-tabs" *ngIf="editingSurveyId">
      <button type="button" [class.active]="surveyEditTab === 'survey'" (click)="setSurveyTab('survey')">
        Editar questionário
      </button>
      <button type="button" [class.active]="surveyEditTab === 'link'" (click)="setSurveyTab('link')">
        Editar link
      </button>
    </div>

    <div class="cp-modal-scroll">
      <ng-container *ngIf="!editingSurveyId || surveyEditTab === 'survey'">
        <section class="panel">
          <div class="cp-form-row">
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Título</mat-label>
              <input matInput type="text" name="survey_title" [(ngModel)]="surveyForm.title" />
            </mat-form-field>
          </div>

          <div class="cp-form-row">
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Descrição</mat-label>
              <textarea matInput rows="3" name="survey_description" [(ngModel)]="surveyForm.description"></textarea>
            </mat-form-field>
          </div>

          <div class="cp-form-row">
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Texto de abertura</mat-label>
              <textarea matInput rows="3" name="survey_intro_text" [(ngModel)]="surveyForm.intro_text"></textarea>
            </mat-form-field>
          </div>

          <div class="cp-form-row">
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Texto de encerramento</mat-label>
              <textarea matInput rows="3" name="survey_outro_text" [(ngModel)]="surveyForm.outro_text"></textarea>
            </mat-form-field>
          </div>

          <div class="cp-form-row">
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Status</mat-label>
              <mat-select name="survey_status" [(ngModel)]="surveyForm.status">
                <mat-option value="DRAFT">Rascunho</mat-option>
                <mat-option value="PUBLISHED">Publicado</mat-option>
                <mat-option value="ARCHIVED">Arquivado</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="cp-field-controls">
            <mat-slide-toggle name="survey_intranet_enabled" [(ngModel)]="surveyForm.intranet_enabled">
              Habilitar questionário na intranet
            </mat-slide-toggle>
          </div>
        </section>
      </ng-container>

      <ng-container *ngIf="editingSurveyId && surveyEditTab === 'link'">
        <section class="panel">
          <div class="link-panel" *ngIf="activeLink">
            <span>Link atual</span>
            <div class="link-row">
              <span class="link-value">{{ generatedLink }}</span>
              <button mat-stroked-button type="button" (click)="copyActiveLink($event)">Copiar</button>
            </div>
            <small class="link-feedback" *ngIf="linkCopied">Link copiado!</small>
          </div>

          <div class="cp-form-row">
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Status do link</mat-label>
              <mat-select name="link_status" [(ngModel)]="linkForm.status">
                <mat-option value="PUBLISHED">Publicado</mat-option>
                <mat-option value="DRAFT">Rascunho</mat-option>
                <mat-option value="EXPIRED">Expirado</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Senha (opcional)</mat-label>
              <input
                matInput
                type="text"
                name="link_password"
                [(ngModel)]="linkForm.password"
                (ngModelChange)="removeLinkPassword = false"
                placeholder="Digite para alterar a senha" />
            </mat-form-field>
          </div>

          <small class="field-hint" *ngIf="linkHasPassword">Senha definida no link.</small>
          <button mat-stroked-button type="button" *ngIf="linkHasPassword" (click)="removeLinkPassword = true; linkForm.password = ''">
            Remover senha
          </button>

          <div class="cp-form-row">
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Data de expiração</mat-label>
              <input matInput type="datetime-local" name="link_expires_at" [(ngModel)]="linkForm.expires_at" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Limite de respostas</mat-label>
              <input matInput type="number" name="link_max_responses" [(ngModel)]="linkForm.max_responses" />
            </mat-form-field>
          </div>

          <div class="cp-form-row">
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>IPs permitidos (separados por vírgula)</mat-label>
              <input matInput type="text" name="link_allowed_ips" [(ngModel)]="linkForm.allowed_ips" placeholder="200.200.200.1, 200.200.200.2" />
            </mat-form-field>
          </div>

          <div class="cp-field-controls">
            <mat-slide-toggle name="link_allow_anonymous" [(ngModel)]="linkForm.allow_anonymous">
              Permitir respostas anônimas
            </mat-slide-toggle>
          </div>
        </section>

        <div class="actions">
          <button mat-stroked-button type="button" (click)="showSurveyModal = false">Cancelar</button>
          <button mat-raised-button color="primary" class="cq-primary-btn" type="button" (click)="activeLink ? saveLinkEdits() : createLink()">
            {{ activeLink ? 'Salvar alterações' : 'Gerar link' }}
          </button>
        </div>
      </ng-container>
    </div>

    <footer class="entry-footer" *ngIf="!editingSurveyId || surveyEditTab === 'survey'">
      <button mat-stroked-button type="button" (click)="showSurveyModal = false">Cancelar</button>
      <button mat-raised-button color="primary" class="cq-primary-btn" type="button" (click)="saveSurvey()">
        {{ editingSurveyId ? 'Salvar alterações' : 'Salvar' }}
      </button>
    </footer>
  </form>
</section>

<div class="modal-backdrop" *ngIf="showQuestionTypeModal" (click)="closeQuestionTypeModal()"></div>
<section class="modal large" *ngIf="showQuestionTypeModal" (click)="$event.stopPropagation()">
  <header>
    <h3>Adicionar pergunta</h3>
    <button class="icon-button" type="button" (click)="closeQuestionTypeModal()">
      <mat-icon>close</mat-icon>
    </button>
  </header>
  <div class="type-grid">
    <div class="type-group" *ngFor="let group of questionTypeGroups">
      <h4>{{ group.name }}</h4>
      <button
        class="type-card"
        type="button"
        [disabled]="!canSelectQuestionType(item)"
        [class.is-disabled]="!canSelectQuestionType(item)"
        *ngFor="let item of group.items"
        (pointerdown)="selectQuestionType(item, $event)"
        (click)="selectQuestionType(item, $event)">
        <div class="type-icon">
          <mat-icon>{{ item.icon }}</mat-icon>
        </div>
        <span>{{ item.label }}</span>
      </button>
    </div>
  </div>
</section>

<div class="modal-backdrop" *ngIf="showMetricsModal" (click)="closeMetricsModal()"></div>
<section class="modal large metrics-modal" *ngIf="showMetricsModal" (click)="$event.stopPropagation()">
  <header>
    <h3>Métricas do questionário</h3>
    <button class="icon-button" type="button" (click)="closeMetricsModal()">
      <mat-icon>close</mat-icon>
    </button>
  </header>
  <div class="metrics-content" *ngIf="metricsSurvey">
    <h4>{{ metricsSurvey.title }}</h4>
    <div class="metrics-summary" *ngIf="surveyMetrics">
      <div class="metric-card">
        <strong>{{ surveyMetrics.total_accesses }}</strong>
        <span>Acessos no link</span>
      </div>
      <div class="metric-card">
        <strong>{{ surveyMetrics.total_responses }}</strong>
        <span>Respostas enviadas</span>
      </div>
      <div class="metric-card">
        <strong>{{ surveyMetrics.total_abandonments }}</strong>
        <span>Abandonos</span>
      </div>
      <div class="metric-card">
        <strong>{{ formatDuration(surveyMetrics.avg_completion_seconds) }}</strong>
        <span>Tempo médio de conclusão</span>
      </div>
      <div class="metric-card">
        <strong>{{ formatDuration(surveyMetrics.avg_abandon_seconds) }}</strong>
        <span>Tempo médio até abandono</span>
      </div>
    </div>
    <p class="metrics-state" *ngIf="metricsLoading">Carregando métricas...</p>
    <p class="metrics-state error" *ngIf="metricsError">{{ metricsError }}</p>
    <div class="question-metrics" *ngIf="surveyMetrics?.questions?.length">
      <div class="question-metric" *ngFor="let question of surveyMetrics.questions">
        <div class="question-header">
          <strong>{{ question.title }}</strong>
          <span>{{ question.total_responses }} respostas</span>
        </div>
        <div class="question-header" *ngIf="['SINGLE_CHOICE','MULTIPLE_CHOICE','IMAGE_CHOICE'].includes(question.question_type) && question.options?.some(hasCorrectOption)">
          <small>Acertos</small>
          <span>{{ question.correct_responses || 0 }} ({{ question.accuracy_percent || 0 }}%)</span>
        </div>
        <div class="option-bars" *ngIf="question.options?.length">
          <div class="option-bar" *ngFor="let option of question.options">
            <span>
              {{ option.label }}
              <small class="correct-tag" *ngIf="option.is_correct">correta</small>
            </span>
            <div class="bar">
              <div class="bar-fill" [style.width.%]="(option.count / maxOptionCount(question.options)) * 100"></div>
            </div>
            <small>{{ option.count }}</small>
          </div>
        </div>
      </div>
    </div>
    <p class="metrics-state" *ngIf="surveyMetrics && !surveyMetrics.questions?.length">Sem respostas registradas.</p>
  </div>
</section>

<div class="cp-modal-backdrop" *ngIf="showLinkModal" (click)="showLinkModal = false"></div>
<section class="modal-card controlquestion-link-modal" *ngIf="showLinkModal" (click)="$event.stopPropagation()">
  <header class="modal-header">
    <div>
      <h2>Gerar link</h2>
      <small>Configure o acesso do questionário para compartilhamento.</small>
    </div>
    <button class="icon" type="button" (click)="showLinkModal = false">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="cp-modal-body">
    <div class="cp-modal-scroll">
      <section class="cp-panel controlquestion-link-panel">
        <ng-container *ngIf="!generatedLink; else linkGenerated">
          <mat-form-field appearance="outline" class="digital-field modal-standard-field">
            <mat-label>Status do link</mat-label>
            <mat-select [(ngModel)]="linkForm.status">
              <mat-option value="PUBLISHED">Publicado</mat-option>
              <mat-option value="DRAFT">Rascunho</mat-option>
              <mat-option value="EXPIRED">Expirado</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="digital-field modal-standard-field">
            <mat-label>Senha (opcional)</mat-label>
            <input
              matInput
              [type]="linkPasswordVisible ? 'text' : 'password'"
              [value]="getLinkPasswordFieldValue()"
              (input)="onLinkPasswordInput(($any($event.target).value || '').toString())">
            <span matSuffix class="link-password-suffix">
              <button
                mat-icon-button
                type="button"
                class="link-password-action"
                [attr.aria-label]="linkPasswordVisible ? 'Ocultar senha' : 'Mostrar senha'"
                (click)="toggleLinkPasswordVisibility()">
                <mat-icon>{{ linkPasswordVisible ? 'visibility' : 'visibility_off' }}</mat-icon>
              </button>
              <button
                mat-icon-button
                type="button"
                class="link-password-action"
                aria-label="Copiar senha"
                (click)="copyLinkPassword()">
                <mat-icon>content_copy</mat-icon>
              </button>
            </span>
          </mat-form-field>

          <mat-form-field appearance="outline" class="digital-field modal-standard-field">
            <mat-label>Data de expiração</mat-label>
            <input matInput type="datetime-local" [(ngModel)]="linkForm.expires_at">
          </mat-form-field>

          <mat-form-field appearance="outline" class="digital-field modal-standard-field">
            <mat-label>Limite de respostas</mat-label>
            <input matInput type="number" [(ngModel)]="linkForm.max_responses">
          </mat-form-field>

          <mat-form-field appearance="outline" class="digital-field modal-standard-field">
            <mat-label>IPs permitidos (separados por vírgula)</mat-label>
            <input matInput type="text" [(ngModel)]="linkForm.allowed_ips" placeholder="200.200.200.1, 200.200.200.2">
          </mat-form-field>

          <div class="cp-field-controls">
            <mat-slide-toggle [(ngModel)]="linkForm.allow_anonymous">Questionário anonimo</mat-slide-toggle>
          </div>
        </ng-container>

        <ng-template #linkGenerated>
          <div class="link-feedback">
            <mat-icon>check_circle</mat-icon>
            <div>
              <strong>Link gerado com sucesso</strong>
              <small>Compartilhe o link abaixo.</small>
            </div>
          </div>
          <div class="link-result">{{ generatedLink }}</div>
          <div class="link-actions">
            <button mat-stroked-button type="button" (click)="startEditLink()">Editar dados</button>
            <button mat-stroked-button type="button" (click)="copyGeneratedLink()">Copiar link</button>
            <button mat-raised-button color="primary" class="cq-primary-btn" type="button" (click)="openGeneratedLink()">Abrir link</button>
          </div>
        </ng-template>
      </section>
    </div>
  </div>

  <footer class="entry-footer" *ngIf="!generatedLink">
    <button mat-stroked-button type="button" (click)="showLinkModal = false">Cancelar</button>
    <button mat-raised-button color="primary" class="cq-primary-btn" type="button" (click)="editingLink ? saveLinkEdits() : createLink()">
      {{ editingLink ? 'Salvar alterações' : 'Gerar link' }}
    </button>
  </footer>
</section>

<div class="modal-backdrop" *ngIf="showPreviewModal" (click)="showPreviewModal = false"></div>
<section class="modal large preview-modal" *ngIf="showPreviewModal" (click)="$event.stopPropagation()">
  <header>
    <h3>Visualização</h3>
    <button class="icon-button" type="button" (click)="showPreviewModal = false">
      <mat-icon>close</mat-icon>
    </button>
  </header>
  <div class="preview-content" *ngIf="activeSurvey">
    <div class="preview-iframe-shell" *ngIf="previewFrameUrl; else previewLinkRequired">
      <iframe
        title="Pré-visualização do questionário"
        class="preview-iframe"
        [src]="previewFrameUrl">
      </iframe>
    </div>
    <ng-template #previewLinkRequired>
      <div class="preview-empty-state">
        <mat-icon>link_off</mat-icon>
        <h4>Gere o link do questionário para visualizar o resultado final.</h4>
        <p>O preview usa a mesma página pública exibida para o usuário final.</p>
      </div>
    </ng-template>
  </div>
</section>
